define('modules/base/base.module',["client", "jquery"],
    function(Prospector, $){
    Prospector.module("ModalApp", function(ModalApp, Prospector, Backbone, Marionette, $, _){
        ModalApp.startWithParent = false;

        ModalApp.onStart = function(){
            window.utils.rawOutput("starting ModalApp");
        };

        ModalApp.onStop = function(){
            window.utils.rawOutput("stopping ModalApp");
        };
    });

    Prospector.module("Routers.ModalApp", function(ModalAppRouter, Prospector, Backbone, Marionette, $, _){
        ModalAppRouter.Router = Marionette.AppRouter.extend({
            appRoutes: {
            }
        });

        var executeAction = function(action, arg){
            Prospector.startSubApp("ModalApp");
            action(arg);
        };

        var API = {
            showModal: function(criterion){
                require(["modules/base/modals/modals.controller"], function(Controller){
                    executeAction(Controller.showModal, criterion);
                });
            }
        };

        Prospector.on("showModal", function(options){
            API.showModal(options);
        });


        Prospector.on("closeTopDrawer", function(options){
            if(Prospector.subMenu != undefined){
                Prospector.subMenu.$(".horizontalIcon").removeClass('active');
                Prospector.subMenu.currentView = "";
            }
        });

        /*Prospector.addInitializer(function(){
            Prospector.trigger("loadCss", "assets/css/modal.css");
            new ModalAppRouter.Router({
                controller: API
            });
        });*/
    });

    return Prospector.ModalAppRouter;
});
